<template lang="pug">
    div
        .title
            slot(name='title')
        form(action='javascript://', v-if='params')
            .form-container
                slot(name='multiplayer')
                template(v-if='!homework || homework.editable === undefined || (homework && (homework.editable || usersIds))')
                    .row(v-if="gameMode !== 'course'")
                        .form-container__column
                            label.form-container__label
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}
                            .form-container__select
                                cs-multiselect(
                                    :multiple='false',
                                    :options='modes',
                                    label='label',
                                    :show-labels='false',
                                    :allow-empty='false',
                                    :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseMode')",
                                    :value="{label: $i18n.t('trainer')[params.mode], value: params.mode}",
                                    @select='selectMode'
                                )
                    .row(v-if="gameMode  ===  'free-game'")
                        .form-container__column
                            label.form-container__label
                                |  {{  $i18n.t('trainer.trainer_gameFormSetting_dictation')  }}
                            cs-checkbox.form-container__select(
                                v-model="params.dictation",
                                @change="dictationClicked"
                            )
                    .row(v-if="gameMode  !==  'generator-settings' && params.dictation")
                        .form-container__column
                            label.form-container__label
                                |  {{  $i18n.t('trainer.trainer_gameFormSetting_timeToAnswer')  }}
                            .form-container__select
                                cs-multiselect(
                                    :options="amountOfSeconds()",
                                    v-model="params.timeForAnswer"
                                    :placeholder="secondsLabel(params.timeForAnswer)"
                                    :multiple="false"
                                    :allow-empty="false"
                                    :custom-label="secondsLabel"
                                )
                    .row(v-if="!onlyMultOrDivChosen")
                        .form-container__column
                            label.form-container__label
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_difficulty') }}
                            .form-container__select
                                cs-multiselect(
                                    :multiple='false',
                                    :options='difficulties',
                                    :show-labels='false',
                                    :allow-empty='false',
                                    track-by='name',
                                    label='label',
                                    :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseDifficulty')",
                                    v-model='selectedDifficult',
                                    @select='difficultHandler'
                                )
                    .row(v-if="isCombiningShown")
                        .form-container__column
                            label.form-container__label
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_combiningNumOfDigits') }}
                            cs-checkbox.form-container__select(
                                v-model="params.combining",
                                :checked='params && params.combining',
                                @change='combiningHandler',
                                :disabled='combiningDisabled'
                            )
                    div(v-if="params.combining")
                        combining-digit-capacity(
                            :filtered-combining-digit-capacities='filteredCombiningDigitCapacities',
                            :combining-digit-capacities='params.combiningDigitCapacities',
                            :combining-digit-capacity-labels='combiningDigitCapacityLabels',
                            @changeCombiningDigitCapacities='changeCombiningDigitCapacities',
                        )
                    .row
                        .form-container__column.form-container__column_fixed
                            label.form-container__label
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfNumbers') }}
                            .form-container__select.form-container__select_short.form-container__select-examples
                                cs-spin-input(
                                    :value="params.numberAmount",
                                    :max="maxNumbersAmount",
                                    :min="3",
                                    @increase="params.numberAmount++",
                                    @decrease="params.numberAmount--",
                                    @input="params.numberAmount = $event",
                                )
                .row(v-if="gameMode !== 'course'")
                    .form-container__column.form-container__column_fixed
                        label.form-container__label
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
                        .form-container__select.form-container__select_short.form-container__select-examples
                            cs-spin-input(
                                :value="params.amountOfExamples",
                                :max="examples",
                                :min="1",
                                @increase="increaseExamples",
                                @decrease="decreaseExamples",
                                @input="params.amountOfExamples = $event",
                                :disabled="params && (params.infinityAmountOfExamples || !!params.timeLimit)"
                            )
                            .form-container__select-infinity-mode(v-if="gameMode && gameMode === 'free-game'")
                                cs-checkbox#infinityAmountOfExamples.form-container__checkbox(
                                    v-model="params.infinityAmountOfExamples"
                                    :checked="params && params.infinityAmountOfExamples"
                                    :disabled="params && (!!params.timeLimit || !!params.dictation)"
                                )
                                svg-icon.form-container__svg-icon(name="infinity" :aria-hidden="true" size="big")
                .row
                    .form-container__column.form-container__column_fixed
                        label.form-container__label.form-container__label_fixed
                            |  {{  $i18n.t('trainer.trainer_gameFormSetting_operations')  }}
                        .form-container__operations
                            .form-container__select.form-container__select_spaced.form-container__select-operation
                                label.form-container__label.form-container__label_fixed.form-container__operation-label(
                                    @click="toggleOperation('add')"
                                )
                                    |   {{  $i18n.t('trainer.trainer_gameSetting_addition')  }}
                                cs-checkbox(
                                    v-model="params.operations.add"
                                    :disabled="isOperationDisabled('add')"
                                )
                            .form-container__select.form-container__select_spaced.form-container__select-operation
                                label.form-container__label.form-container__label_fixed.form-container__operation-label(
                                    @click="toggleOperation('subtract')"
                                )
                                    |   {{  $i18n.t('trainer.trainer_gameSetting_subtraction')  }}
                                cs-checkbox(
                                    v-model="params.operations.subtract"
                                    :disabled="isOperationDisabled('subtract')"
                                )
                            .form-container__select.form-container__select_spaced.form-container__select-operation
                                label.form-container__label.form-container__label_fixed.form-container__operation-label(
                                    @click="toggleOperation('multiply')"
                                )
                                    |   {{  $i18n.t('trainer.trainer_gameFormSetting_multiplication')  }}
                                cs-checkbox(
                                    v-model="params.operations.multiply"
                                    :disabled="isOperationDisabled('multiply')"
                                )
                            .form-container__select.form-container__select_spaced.form-container__select-operation
                                label.form-container__label.form-container__label_fixed.form-container__operation-label(
                                    @click="toggleOperation('divide')"
                                )
                                    |   {{  $i18n.t('trainer.trainer_gameFormSetting_division')  }}
                                cs-checkbox(
                                    v-model="params.operations.divide"
                                    :disabled="isOperationDisabled('divide')"
                                )
                .row.multiplication-digits-container(v-if="multOrDivChosen && !AddOrSubChosen")
                    .form-container__row-column
                        label.multiplication-digits__label
                            |   {{ $i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier') }}
                        .form-container__select
                            cs-checkbox(
                                    v-for="(value, key) in digitCapacity"
                                        @change="setKey('left', +key)"
                                        :checked="!!params.multDivDigitCapacity.left.find(capacity => capacity === +key)"
                                        :disabled="isMultDivCapacityDisabled('left', key)"
                                    )
                                |   {{ value }}
                    .form-container__row-column
                        label.multiplication-digits__label
                            |   {{ $i18n.t('trainer.trainer_gameFormSetting_dividerMultiplier') }}
                        .form-container__select
                            cs-checkbox(
                                    v-for="(value, key) in digitCapacity"
                                        @change="setKey('right', +key)"
                                        :checked="!!params.multDivDigitCapacity.right.find(capacity => capacity === +key)"
                                        :disabled="isMultDivCapacityDisabled('right', key)"
                                    )
                                |   {{ value }}
                    divider(margin="15px")
                .row
                    .form-container__column.form-container__column_fixed
                        label.form-container__label.form-container__label_fixed
                            |   {{ $i18n.t('trainer.trainer_gameSetting_pairsOfBrackets')  }}
                        .form-container__select.form-container__select_spaced
                            cs-checkbox(
                                v-model="params.bracketsEnabled"
                            )
                .row(v-if="params.bracketsEnabled")
                    .form-container__column.form-container__column_fixed
                        label.form-container__label
                            |   {{ $i18n.t('trainer.trainer_gameSetting_amountOfBracketPairs')  }}
                        .form-container__select.form-container__select_short.form-container__select-examples
                            cs-spin-input(
                                :value="params.bracketAmount",
                                :max="maxBracketsAmount",
                                :min="1",
                                @increase="params.bracketAmount++",
                                @decrease="params.bracketAmount--",
                                @input="params.bracketAmount = $event",
                            )
                template(v-if="gameMode !== 'course'")
                    .row
                        .form-container__column.form-container__column_fixed
                            label.form-container__label.form-container__label_fixed
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_fractions') }}
                            .form-container__select.form-container__select_spaced
                                cs-checkbox#fractions(
                                    :checked='params && params.fractions',
                                    @change='fractionsHandler',
                                )
                    .row(v-if='params.fractions')
                        .form-container__column
                            label.form-container__label
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_numbersAfterPoints') }}
                            .form-container__select
                                cs-multiselect(
                                    v-model='params.fractionalPart',
                                    :options="fractionalPart",
                                    :multiple="false",
                                    :searchable="false",
                                    :allow-empty="false",
                                    :show-labels="false",
                                )
                    .form-container__info.help-text(v-if="multOrDivChosen && params.fractions")
                        span
                            | {{ $i18n.t('trainer.trainer_gameSetting_answerRoundingInfo') }}
                    .row
                        .form-container__column.form-container__column_fixed
                            label.form-container__label.form-container__label_fixed
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_positiveAnswers') }}
                            .form-container__select.form-container__select_spaced
                                cs-checkbox#positiveAnswers(
                                    v-model='params.positiveAnswers',
                                    :checked="params && params.positiveAnswers",
                                    :disabled="positiveAnswersDisabled"
                                )
                    .row
                        .form-container__column.form-container__column_fixed
                            label.form-container__label.form-container__label_fixed
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_negativeAnswers') }}
                            .form-container__select.form-container__select_spaced
                                cs-checkbox#negativeAnswers(
                                    v-model='params.negativeAnswers',
                                    :checked='params && params.negativeAnswers',
                                    :disabled="negativeAnswersDisabled"
                                )
                slot(name='parameters')
                .help-text
                    slot(name='help')
                .form-container__warning(v-if="!enableSave")
                    span
                        | {{ $i18n.t('trainer.trainer_gameSetting_amountOfBracketWarning') }}
                template(v-if='!usersIds')
                    .form-container__footer-buttons
                        cs-button.cancel-button(type='button', @click='cancel', pattern="primary-outline", color="blue")
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                        template(v-if="gameMode && gameMode === 'free-game'")
                            cs-button.save-button(
                                :disabled="!enableSave"
                                type='button',
                                @click='saveGameMode',
                                color="blue"
                            )
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                        template(v-else)
                            cs-button.save-button(
                                :disabled="!enableSave"
                                type='button',
                                @click='saveGame',
                                color="blue"
                            )
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                template(v-else)
                    .form-container__footer-buttons
                        cs-button.cancel-button(type='button', @click='cancel', pattern="primary-outline", color="blue")
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                        cs-button.save-button(
                            :disabled="!enableSave"
                            type='button',
                            color="blue",
                            @click='saveGame'
                        )
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
</template>

<script>
    import _ from 'lodash';
    import { mapState } from 'vuex';
    import TrainerGames from '../../../config/trainer';
    import GameFormMixin from '../../../utils/trainer/GameFormMixin';
    import { getInitParameters } from '../../../utils/trainer/getInitParameters';
    const DEFAULT_TIME_LIMIT = 0;
    const MAX_NUMBER_AMOUNT = 15;
    const MULT_DIV_MAX_NUMBER_AMOUNT = 5;
    const MAX_BRACKET_AMOUNT = 10;
    const MULT_DIV_MAX_BRACKET_AMOUNT = 3;
    import multiplayerFormMixin from '../../../utils/multiplayer/formMixin';
    import speedHelpTextMixin from '../utils/speedHelpTextMixin';
    import combiningCapacitiesMixin from '../utils/combiningCapacitiesMixin';
    import CombiningDigitCapacity from '../shared/CombiningDigitCapacity.vue';

    export default {
        components: {
            CombiningDigitCapacity,
        },
        props: [
            'slug',
            'courseType',
            'id',
            'usersIds',
            'homeworkId',
            'gameMode',
            'levelAnswerDuration',
            'gameId',
            'generatorSettings',
            'generatorGameIndex',
        ],
        data() {
            return {
                modes: [
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbacus'),
                        value: 'На счетах',
                    },
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSettingValue_inMind'),
                        value: 'В уме',
                    },
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSettingValue_any'),
                        value: 'Любой',
                    },
                ],
                digitCapacity: {
                    1: this.$i18n.t('common.common_gameSetting_digitCapacity1'),
                    2: this.$i18n.t('common.common_gameSetting_digitCapacity2'),
                    3: this.$i18n.t('common.common_gameSetting_digitCapacity3'),
                    4: this.$i18n.t('common.common_gameSetting_digitCapacity4'),
                    5: this.$i18n.t('common.common_gameSetting_digitCapacity5'),
                    6: this.$i18n.t('common.common_gameSetting_digitCapacity6'),
                    7: this.$i18n.t('common.common_gameSetting_digitCapacity7'),
                    8: this.$i18n.t('common.common_gameSetting_digitCapacity8'),
                },
                difficulties: [
                    {
                        label: this.$i18n.t('common.common_gameSetting_singleDigitNum'),
                        name: 'Однозначные цифры',
                        $isDisabled: false,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_doubleDigitsNum'),
                        name: 'Двузначные цифры',
                        $isDisabled: false,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_tripleDigitsNum'),
                        name: 'Трехзначные цифры',
                        $isDisabled: false,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_fourDigitsNum'),
                        name: 'Четырехзначные цифры',
                        $isDisabled: false,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_fiveDigitsNum'),
                        name: 'Пятизначные цифры',
                        $isDisabled: false,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_sixDigitsNum'),
                        name: 'Шестизначные цифры',
                        $isDisabled: false,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_sevenDigitsNum'),
                        name: 'Семизначные цифры',
                        $isDisabled: false,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_eightDigitsNum'),
                        name: 'Восьмизначные цифры',
                        $isDisabled: false,
                    },
                ],
                params: null,
                selectedDifficult: null,
                examples: 100,
                secondsInMinute: [...Array(61).keys()].slice(1).map(time => {
                    return {
                        time: time,
                        label: `${time} ` + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds'),
                    };
                }),
                dictationSeconds: [...Array(101).keys()].slice(1).map(time => {
                    return {
                        time: time,
                        label: `${time} ` + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds'),
                    };
                }),
                fractionalPart: [...Array(3).keys()].slice(1),
            };
        },
        mixins: [GameFormMixin, multiplayerFormMixin, speedHelpTextMixin, combiningCapacitiesMixin],
        mounted() {
            if (this.gameMode === 'free-game') {
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = _.cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else if (this.gamesParameters) {
                    this.params = getInitParameters({
                        slug: this.slug,
                        parameters: {
                            default: _.cloneDeep(this.gamesParameters[this.slug]),
                        },
                    });
                    let difficultIndex = this.difficulties
                        .map(difficulty => difficulty.name)
                        .indexOf(this.gamesParameters[this.slug].difficult);
                    for (let i = difficultIndex + 1; i < this.difficulties.length; i++) {
                        this.difficulties[i].$isDisabled = true;
                    }
                } else {
                    _.cloneDeep(TrainerGames.games).forEach(item => {
                        if (item.slug === this.slug) {
                            this.params = item.parameters.default;
                        }
                    });
                }
                this.params.infinityAmountOfExamples = true;
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
            this.selectedDifficult = _.find(this.difficulties, { name: this.params.difficult });
        },
        watch: {
            'params.amountOfExamples'(val) {
                if (this.params.tasksForSpeedUp >= this.params.amountOfExamples && this.params.amountOfExamples !== 1) {
                    this.params.tasksForSpeedUp = this.params.amountOfExamples - 1;
                }
                if (this.params.timeLimit) {
                    this.params.tasksForComplication = 1;
                } else if (this.params.tasksForComplication >= val && val !== 1) {
                    this.params.tasksForComplication = val - 1;
                }
                if (val) {
                    this.params.timeLimit = DEFAULT_TIME_LIMIT;
                }
            },
            'params.negativeAnswers'(val) {
                if (val && !this.params.operations.subtract) {
                    this.params.operations.subtract = true;
                }
            },
            'params.operations.subtract'(val) {
                if (!val) {
                    this.params.negativeAnswers = false;
                    this.params.positiveAnswers = true;
                }
            },
            'params.dictation'(val) {
                if (val) {
                    this.params.infinityAmountOfExamples = false;
                }
            },
            onlyMultOrDivChosen(val) {
                if (val) {
                    this.params.numberAmount = Math.min(this.params.numberAmount, MULT_DIV_MAX_NUMBER_AMOUNT);
                    this.params.bracketAmount = Math.min(this.params.bracketAmount, MULT_DIV_MAX_BRACKET_AMOUNT);
                }
            },
            selectedDifficult(val) {
                this.params.difficult = val.name;
            },
            isCombiningShown(val) {
                if (!val) {
                    this.params.combining = false;
                }
            },
            'params.bracketsEnabled'(val) {
                if (!val) {
                    this.params.bracketAmount = 1;
                }
            },
            onlyDivisionChosen(val) {
                if (val) {
                    this.params.multDivDigitCapacity.left = [];
                } else {
                    this.params.multDivDigitCapacity.left = [1];
                }
            },
        },
        methods: {
            dictationClicked() {
                this.params.timeForAnswer = this.params.dictation ? 1 : '-1';
            },
            decreaseExamples() {
                if (
                    this.params.amountOfExamples !== 1 &&
                    !this.params.timeLimit &&
                    !this.params.infinityAmountOfExamples
                ) {
                    this.params.amountOfExamples -= 1;
                }
            },
            amountOfSeconds() {
                return _.range(1, 101);
            },
            increaseExamples() {
                if (
                    this.params.amountOfExamples !== this.examples &&
                    !this.params.timeLimit &&
                    !this.params.infinityAmountOfExamples
                ) {
                    this.params.amountOfExamples += 1;
                }
            },
            secondsLabel(amount) {
                if (!this.params.dictation) {
                    return amount == -1
                        ? this.$i18n.t('trainer.trainer_gameFormSettingValue_off')
                        : amount + ' ' + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds');
                }
                return amount + ' ' + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds');
            },
            combiningHandler(combining) {
                this.params.combining = combining;
                this.params.combiningDigitCapacities = [];
                if (combining) {
                    this.fillCombiningDigitCapacities();
                }
            },
            difficultHandler(difficult) {
                difficult = difficult.name;
                this.params.difficult = difficult;
                if (difficult === 'Однозначные цифры') {
                    this.params.combining = false;
                }
                if (this.params.combining) {
                    this.fillCombiningDigitCapacities();
                }
                if (this.combiningDisabled) {
                    this.params.combiningDigitCapacities = [];
                }
            },
            fractionsHandler() {
                this.params.fractions = !this.params.fractions;
                if (this.params.fractions && this.params.combining) {
                    this.fillCombiningDigitCapacities();
                }
            },
            selectMode(mode) {
                this.params.mode = mode.value;
            },
            isOperationDisabled(operation) {
                return !Object.entries(this.params.operations).find(value => value[0] !== operation && value[1]);
            },
            isMultDivCapacityDisabled(key, value) {
                return (
                    (key === 'left' && this.onlyDivisionChosen) ||
                    (this.params.multDivDigitCapacity[key].length === 1 &&
                        !!this.params.multDivDigitCapacity[key].find(capacity => capacity === +value))
                );
            },
            toggleOperation(operation) {
                if (!this.isOperationDisabled(operation)) {
                    this.params.operations[operation] = !this.params.operations[operation];
                }
            },
            setKey(key, value) {
                this.params.multDivDigitCapacity[key] = _.xor(this.params.multDivDigitCapacity[key], [value]);
            },
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user,
            }),
            positiveAnswersDisabled() {
                return this.params.positiveAnswers && !this.params.negativeAnswers;
            },
            negativeAnswersDisabled() {
                return this.params.negativeAnswers && !this.params.positiveAnswers;
            },
            enableSave() {
                return this.params.numberAmount - this.params.bracketAmount >= 2;
            },
            multOrDivChosen() {
                return this.params?.operations.multiply || this.params?.operations.divide;
            },
            onlyMultOrDivChosen() {
                return this.multOrDivChosen && !this.AddOrSubChosen;
            },
            AddOrSubChosen() {
                return this.params?.operations.add || this.params?.operations.subtract;
            },
            onlyDivisionChosen() {
                return (
                    this.params?.operations.divide &&
                    Object.values(this.params.operations).filter(operation => operation).length === 1
                );
            },
            combiningDisabled() {
                return this.params && this.params.difficult === 'Однозначные цифры';
            },
            maxNumbersAmount() {
                return this.onlyMultOrDivChosen ? MULT_DIV_MAX_NUMBER_AMOUNT : MAX_NUMBER_AMOUNT;
            },
            maxBracketsAmount() {
                return this.onlyMultOrDivChosen ? MULT_DIV_MAX_BRACKET_AMOUNT : MAX_BRACKET_AMOUNT;
            },
            isCombiningShown() {
                return this.gameMode !== 'course' && !this.onlyMultOrDivChosen && !this.params?.fractions;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .title {
        margin-bottom: 25px;
        display: flex;
        justify-content: center;
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
    }
    .row {
        margin: 0;
    }
    .multiplication-digits-container {
        display: flex;
        justify-content: space-around;
    }
    .multiplication-digits__label {
        display: inline-block;
        margin-bottom: 15px;
    }
    .form-container {
        width: 100%;
        max-width: 1020px;
        margin: 0 auto;
    }
    .form-container__row-column {
        margin-bottom: 20px;
    }
    .form-container__column {
        width: 100%;
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        @media screen and (max-width: 767px) {
            flex-direction: column;
        }
    }
    .form-container__column_fixed {
        @media screen and (max-width: 767px) {
            flex-direction: row;
        }
        @media screen and (max-width: 575px) {
            flex-direction: row;
        }
    }
    .form-container__label {
        margin-right: 20px;
        width: 30%;
        text-align: right;
        @media screen and (max-width: 767px) {
            width: 100%;
            margin: 0 0 10px 0;
            text-align: left;
        }
    }
    .form-container__transition-through {
        width: auto;
    }
    .form-container__label_fixed {
        @media screen and (max-width: 767px) {
            margin-right: 20px;
            width: 100%;
            text-align: right;
        }
        @media screen and (max-width: 575px) {
            text-align: left;
            margin-right: 0;
        }
    }
    .input-label {
        @media screen and (max-width: 767px) {
            text-align: left;
        }
    }
    .form-container__select {
        width: 100%;
        max-width: 300px;
        @media screen and (max-width: 767px) {
            max-width: none;
        }
    }
    .form-container__select_spaced {
        @media screen and (max-width: 575px) {
            width: auto;
        }
    }
    .form-container__select_short {
        display: flex;
        align-items: center;
    }
    .form-container__select-examples {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        @media screen and (min-width: 700px) {
            flex-direction: row;
            align-items: center;
        }
    }
    .form-container__settings {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        margin-bottom: 40px;
    }
    .form-container__select-infinity-mode {
        display: flex;
        align-items: center;
        margin-top: 20px;
        @media screen and (min-width: 700px) {
            margin-top: 0;
        }
    }
    .form-container__checkbox {
        margin-left: 30px;
    }
    .form-container__svg-icon {
        opacity: 0.7;
        margin: 0 10px 10px 0;
    }
    .form-container__operations {
        display: flex;
        flex-direction: column;
        width: 100%;
        max-width: 300px;
        @include media($md) {
            margin-left: -60px;
            width: auto;
        }
        @include media($xl) {
            margin-left: 0;
            flex-direction: row;
        }
        .form-container__select {
            @include media($md) {
                margin-right: 30px;
            }
        }
    }
    .form-container__operation-label {
        display: block;
        cursor: pointer;
        padding-right: 15px;
        margin-bottom: 14px;
        text-align: right;
        @include media($sm) {
            text-align: left;
        }
    }
    .form-container__select-operation {
        display: flex;
        align-items: flex-end;
        text-align: right;

        @include media($sm) {
            text-align: left;
            flex-direction: row-reverse;
        }
    }
    .setting__checkbox {
        margin-right: 30px;
        @media screen and (max-width: 991px) {
            margin-bottom: 30px !important;
        }
        @media screen and (max-width: 575px) {
            margin-bottom: 40px !important;
        }
        @media screen and (max-width: 359px) {
            margin-right: 20px;
        }
    }
    .settings-header {
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        margin-bottom: 20px;
    }
    .form-container__warning {
        margin-top: 10px;
        margin-bottom: 10px;
        color: $hsl-color-red-62;
    }
    .form-container__info {
        margin-bottom: 20px;
    }
    .form-container__footer-buttons {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        @media screen and (max-width: 767px) {
            flex-direction: column;
        }
    }
    .cancel-button {
        width: 200px;
    }
    .save-button {
        width: 200px;
        margin-left: 20px;
        @media screen and (max-width: 767px) {
            margin: 20px 0 0 0;
        }
    }
    .help-text {
        color: #888888;
    }
</style>
